module.exports = [{
      plugin: require('/home/tomasz/projekty/dietlabs-new/byAnnPl-landings/node_modules/gatsby-plugin-sentry/gatsby-browser.js'),
      options: {"plugins":[],"enabled":true,"dsn":"https://8f2781e64bb04854a5c0e2370b7c5849@sentry.io/1454229","release":"0.1.43","environment":"production","debug":false},
    },{
      plugin: require('/home/tomasz/projekty/dietlabs-new/byAnnPl-landings/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
